import $ from 'jquery';
import 'slick-carousel';

export default function sliderGrand() {

    const $sliderGrand = $('.js-slider-grand');
    const $brandProgress = $('.js-slider-grand-progress .progress-fill');

    if ($sliderGrand.length) {
        function updateSliderGrandProgress(slick, currentSlide) {
            const slidesToShow = slick.options.slidesToShow;
            const totalSlides = slick.slideCount;
            const maxSteps = Math.max(totalSlides - Math.floor(slidesToShow), 1);
            const step = Math.min(currentSlide, maxSteps);
            const adjustedProgress = 8 + (step / maxSteps) * 92;
            $brandProgress.css('width', `${adjustedProgress}%`);
        }

        function initSliderGrand() {
            $sliderGrand.slick({
                slidesToShow: 4.2,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: $('.js-slider-grand-prev'),
                nextArrow: $('.js-slider-grand-next'),
                infinite: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 2500,
                        settings: { slidesToShow: 3.5 }
                    },
                    {
                        breakpoint: 1300,
                        settings: { slidesToShow: 2.4 }
                    },
                    {
                        breakpoint: 1024,
                        settings: { slidesToShow: 1.25 }
                    }
                ]
            });

            $sliderGrand.on('init reInit', (e, slick) => {
                updateSliderGrandProgress(slick, slick.currentSlide);
            });

            $sliderGrand.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
                updateSliderGrandProgress(slick, nextSlide);
            });
        }

        initSliderGrand();
    }

    const $sliderTestimonials = $('.js-slider-testimonial');

    if ($sliderTestimonials.length) {
        $sliderTestimonials.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            adaptiveHeight: true,
            fade: true,
            cssEase: 'ease',
            prevArrow: $('.js-slider-test-prev'),
            nextArrow: $('.js-slider-test-next')
        });
    }

    const $sliderCentered = $('.js-slider-centered');

    if ($sliderCentered.length) {
        $sliderCentered.slick({
            centerMode: true,
            centerPadding: '12.5%',
            slidesToShow: 3,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: '12.5%',
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '15%',
                    }
                }
            ]
        });
    }

    const $sliderUsps = $('.js-usps-image');
    const isMobile = Foundation.MediaQuery.upTo('medium');

    if ($sliderUsps.length && isMobile) {
        $sliderUsps.slick({
            slidesToShow: 1.286,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            responsive: []
        });
    }

    const $sliderProductImages = $('.js-slider-product-image');

    $sliderProductImages.each(function () {
        const $slider = $(this);
        const $container = $slider.closest('.product');

        const $prev = $container.find('.js-slider-product-image-prev');
        const $next = $container.find('.js-slider-product-image-next');

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            prevArrow: $prev,
            nextArrow: $next,
            swipe: Foundation.MediaQuery.atLeast('medium'),
        });
    });

    const $sliderProductGrid = $('.js-slider-product-grid');
    const $gridProgress = $('.js-slider-product-grid-progress .progress-fill');

    if ($sliderProductGrid.length) {
        function updateSliderProductGridProgress(slick, currentSlide) {
            const slidesToShow = slick.options.slidesToShow || 1;
            const totalSlides = slick.slideCount;
            const maxSteps = Math.max(totalSlides - Math.floor(slidesToShow), 1);
            const step = Math.min(currentSlide, maxSteps);
            const adjustedProgress = 8 + (step / maxSteps) * 92;
            $gridProgress.css('width', `${adjustedProgress}%`);
        }

        function sliderProductGrid() {
            if (Foundation.MediaQuery.atLeast('medium')) {
                if ($sliderProductGrid.hasClass('slick-initialized')) {
                    $sliderProductGrid.slick('unslick');
                }
            } else {
                if (!$sliderProductGrid.hasClass('slick-initialized')) {
                    $sliderProductGrid.slick({
                        slidesToShow: 1.25,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false,
                        infinite: false,
                        adaptiveHeight: true,
                        prevArrow: $('.js-slider-product-grid-prev'),
                        nextArrow: $('.js-slider-product-grid-next')
                    });

                    $sliderProductGrid.on('init reInit beforeChange', function (e, slick, currentSlide, nextSlide) {
                        if (e.target !== $sliderProductGrid.get(0)) return; // Prevent bubbling from nested sliders

                        const activeSlide = typeof nextSlide !== 'undefined' ? nextSlide : slick.currentSlide;
                        updateSliderProductGridProgress(slick, activeSlide);
                    });
                }
            }
        }

        sliderProductGrid();
        $(window).on('changed.zf.mediaquery', sliderProductGrid);
    }

    const $track = $('.js-logos-track');

    if ($track.length) {
        $track.slick({
            slidesToShow: 8,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 9000,
            cssEase: 'linear',
            pauseOnHover: false,
            pauseOnFocus: false,
            swipe: true,
            touchMove: true,
            draggable: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });

        $track.on('swipe', function () {
            $track.slick('slickPlay');
        });
    }

}
